<template>
    <div class="SoftwareShowcase">
        <div class="pageContent">
            <TopLogoBar logoColor="black" logoSpecial="software" textColor="#000"
                title="SOLUZIONI GESTIONALI PER LE IMPRESE"
                :subtitle="selectedApp != null ? subtitleGroup[selectedApp.subtitle] : null" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-12">
                        <div class="descriptionText" v-if="selectedApp != null">
                            <div class="appLogo">
                                <img :src="selectedApp.image" :class="{open: showDescription}" />

                                <!--<div class="arrowContainer" @click="showDescription = !showDescription"
                                    :class="{reverse: showDescription}">
                                    <i class="arrow">
                                        <span></span>
                                    </i>
                                </div>-->

                                <div class="arrowContainer ">
                                    <i class="arrow">
                                        <span></span>
                                    </i>
                                </div>
                            </div>
                            <div class="appDescription" :style="{'background-color': selectedApp.color}"
                                v-if="showDescription == true">
                                {{ selectedApp.description }}

                            </div>
                            <div class="prevApp" v-if="selectedApp.prevApp != null">
                                <img :src="selectedApp.prevApp.image" @click="selectAppById(selectedApp.prevAppId)" />
                            </div>
                            <div class="nextApp" v-if="selectedApp.nextApp != null">
                                <img :src="selectedApp.nextApp.image" @click="selectAppById(selectedApp.nextAppId)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'SoftwareShowcase',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
        data() {
            return {
                currentApp: 0,
                showDescription: true,
                selectedApp: null,
                subtitleGroup: [
                    'food and retail',
                    'other industrial sectors'
                ],
                apps: [{
                        name: 'Beauty',
                        description: `Beauty è il software veloce ed efficiente, realizzato per
soddisfare le esigenze delle aziende di distribuzione
e vendita prodotti di bellezza, profumi, cosmetici,
prodotti d’igiene, articoli per parrucchieri, erboristerie,
bigiotterie. La soluzione ideale per il beauty shop che
tramite l’integrazione con Mago.net gestisce tutte le
esigenze delle catene di vendita.`,
                        image: require('@/assets/images/loghi/beauty.png'),
                        color: '#f5a3b0',
                        subtitle: 0
                    },
                    {
                        name: 'Golden',
                        description: `Golden è un prodotto altamente professionale, affidabile,
semplice e orientato alla risoluzione di tutte le esigenze
e le problematiche legate alla gestione di un negozio di
gioielleria. E’ il software realizzato per soddisfare le
necessità delle aziende che effettuano la distribuzione
e vendita di prodotti preziosi, settori ove i prezzi della
materia prima sono in costante variazione.`,
                        image: require('@/assets/images/loghi/golden.png'),
                        color: '#ceac4f',
                        subtitle: 0
                    },
                    {
                        name: 'EatUp',
                        description: `Eat Up Cosy Restaurant è la procedura semplice, veloce
ed efficiente, che permette di gestire in totalità il tuo
ristorante. Dalla cucina, con i monitor che smistano il flusso
delle comande con tempi e modalità di preparazione, alla
sala ristorante, con l’emissione della fattura o scontrino.`,
                        image: require('@/assets/images/loghi/eatup.png'),
                        color: '#c22028',
                        subtitle: 0
                    },
                    {
                        name: 'Mobyle',
                        description: `Mobyle è l’app per gestire, in mobilità su dispositivi IOS
ed Android, qualsiasi tipo di itinerario preveda consegne,
visite, raccolta ordini, tentate vendite. Con Mobyle
aumentano sensibilmente le performance della forza
vendita, tenendo sempre a portata di mano contatti,
clienti, ordini, consegne ed appuntamenti.`,
                        image: require('@/assets/images/loghi/mobyle.png'),
                        color: '#3c549b',
                        subtitle: 0
                    }
                    /*,
                    {
                        name: 'VenBan.Pack',
                        description: `VenBan.Pack, nelle versioni Shop e Tecnik per la gestione
della vendita al banco sia che si tratti di attività con
commercio all’ingrosso che minuto, permette di gestire le
Fidelity, gli inventari e i listini prezzi. E’ particolarmente
indicato per le attività di vendita piastrelle, arredo
bagno, idraulica, termosanitaria, ferramenta, alimentari,
abbigliamento e cartolerie.`,
                        image: require('@/assets/images/loghi/mobyle.png'),
                        color: '#3c549b'
                    },*/
                ]
            }
        },
        methods: {
            searchAppByName(name) {
                for (let i in this.apps) {
                    if (this.apps[i].name.toLowerCase() == name.toLowerCase())
                        return i
                }
                return 0;
            },
            selectAppById(id, changeRoute = true) {
                this.selectedApp = this.apps[id]

                if (id == 0) {
                    this.selectedApp.prevApp = this.apps[this.apps.length - 1]
                    this.selectedApp.prevAppId = this.apps.length - 1
                } else {
                    this.selectedApp.prevApp = this.apps[(Number(id) - 1)]
                    this.selectedApp.prevAppId = Number(id) - 1
                }

                if (this.apps.length - 1 == Number(id)) {
                    this.selectedApp.nextAppId = 0
                    this.selectedApp.nextApp = this.apps[0]
                } else {
                    this.selectedApp.nextApp = this.apps[(Number(id) + 1)]
                    this.selectedApp.nextAppId = Number(id) + 1
                }

                //this.showDescription = false
                if (changeRoute)
                    this.$router.push('/showcase/' + this.selectedApp.name.toLowerCase())
            }
        },
        mounted() {
            if (this.$route.params.appName) {
                this.currentApp = this.searchAppByName(this.$route.params.appName)
            }

            this.selectAppById(this.currentApp, false)

        }
    }
</script>

<style scoped lang="scss">
    .SoftwareShowcase {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            .infoContainer {
                padding: 20px;
            }

            .descriptionText {
                font-size: 1.1rem;
                display: grid;
                grid-template-columns: 1fr 65% 1fr;
                grid-template-rows: repeat(auto-fit, minmax(0, 1fr));
                grid-column-gap: 20px;
                grid-row-gap: 20px;
                justify-items: center;
                align-items: center;

                @media only screen and (min-width: 768px) {
                    margin-left: 100px;
                    margin-right: 100px;
                    margin-top: 30px;
                }

                .appLogo {
                    grid-column: 2;
                    grid-row: 1;

                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    img {
                        transition: all .5s ease-in-out;
                        max-height: 400px;

                        width: auto;
                        object-fit: contain;

                        /*    &.open {
                           // height: 350px;
                        }*/
                    }
                }

                .appDescription {
                    grid-column: 2;
                    grid-row: 2;
                    padding: 20px;
                    color: #fff;
                    font-weight: 500;
                    text-align: center;
                    border-radius: 8px;

                    @media only screen and (max-width: 768px) {
                        grid-column-start: 1;
                        grid-column-end: 4;
                    }
                }

                .prevApp {
                    grid-column: 1;
                    grid-row: 1;
                    align-self: end;

                    cursor: pointer;
                }

                .nextApp {
                    grid-column: 3;
                    grid-row: 1;
                    align-self: end;

                    cursor: pointer;
                }
            }
        }
    }
</style>